import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgAmenityShuttle = function SvgAmenityShuttle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M992 240h-64v-32c0-89.6-70.4-160-160-160H256c-89.6 0-160 70.4-160 160v32H32c-19.2 0-32 12.8-32 32v160c0 19.2 12.8 32 32 32h64v384c0 19.2 12.8 32 32 32h48v64c0 19.2 12.8 32 32 32h128c19.2 0 32-12.8 32-32v-64h288v64c0 19.2 12.8 32 32 32h128c19.2 0 32-12.8 32-32v-64h48c19.2 0 32-12.8 32-32V464h64c19.2 0 32-12.8 32-32V272c0-19.2-12.8-32-32-32M96 400H64v-96h32zm64-96h320v224H160zm704 512H160V592h704zm0-288H544V304h320zm0-288H160v-32c0-54.4 41.6-96 96-96h512c54.4 0 96 41.6 96 96zm96 160h-32v-96h32zM224 704c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48m480 0c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmenityShuttle);

export { ForwardRef as default };
